import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export const AdminPrivateRoute = ({ component: Component, tokenState, componentProps, ...rest }: any): any => {

  return (
    <Route
      {...rest}
      render={(props): React.ReactElement =>
        tokenState ? (
          <Component {...props} {...componentProps} />
        ) : (
          <Redirect
            to={{
              pathname: '/login',
            }}
          />
        )
      }
    />
  );
};
